/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';

/**
 * 
 * @export
 * @interface IntegrationModes
 */
export interface IntegrationModes  {
    /**
     * 
     * @type {boolean}
     * @memberof IntegrationModes
     */
    orcidGetWorksMode?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof IntegrationModes
     */
    orcidPostWorksMode?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof IntegrationModes
     */
    orcidGetPersonDataMode?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof IntegrationModes
     */
    orcidPostPersonDataMode?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof IntegrationModes
     */
    orcidPostActivityDataMode?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof IntegrationModes
     */
    orcidGetActivityDataMode?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof IntegrationModes
     */
    orcidSyncOnUnlinkedProfilesMode?: boolean;
}

/**
 * Check if a given object implements the IntegrationModes interface.
 */
export function instanceOfIntegrationModes(value: object): value is IntegrationModes {
    return true;
}

export function IntegrationModesFromJSON(json: any): IntegrationModes {
    return IntegrationModesFromJSONTyped(json, false);
}

export function IntegrationModesFromJSONTyped(json: any, ignoreDiscriminator: boolean): IntegrationModes {
    if (json == null) {
        return json;
    }
    return {
        
                  'orcidGetWorksMode': json['orcidGetWorksMode'] == null ? undefined : json['orcidGetWorksMode'],
                  'orcidPostWorksMode': json['orcidPostWorksMode'] == null ? undefined : json['orcidPostWorksMode'],
                  'orcidGetPersonDataMode': json['orcidGetPersonDataMode'] == null ? undefined : json['orcidGetPersonDataMode'],
                  'orcidPostPersonDataMode': json['orcidPostPersonDataMode'] == null ? undefined : json['orcidPostPersonDataMode'],
                  'orcidPostActivityDataMode': json['orcidPostActivityDataMode'] == null ? undefined : json['orcidPostActivityDataMode'],
                  'orcidGetActivityDataMode': json['orcidGetActivityDataMode'] == null ? undefined : json['orcidGetActivityDataMode'],
                  'orcidSyncOnUnlinkedProfilesMode': json['orcidSyncOnUnlinkedProfilesMode'] == null ? undefined : json['orcidSyncOnUnlinkedProfilesMode'],
    };
}

export function IntegrationModesToJSON(json: any): IntegrationModes {
    return IntegrationModesToJSONTyped(json, false);
}

export function IntegrationModesToJSONTyped(value?: IntegrationModes | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }
    return {
        
        'orcidGetWorksMode': value['orcidGetWorksMode'],
        'orcidPostWorksMode': value['orcidPostWorksMode'],
        'orcidGetPersonDataMode': value['orcidGetPersonDataMode'],
        'orcidPostPersonDataMode': value['orcidPostPersonDataMode'],
        'orcidPostActivityDataMode': value['orcidPostActivityDataMode'],
        'orcidGetActivityDataMode': value['orcidGetActivityDataMode'],
        'orcidSyncOnUnlinkedProfilesMode': value['orcidSyncOnUnlinkedProfilesMode'],
    };
}


